/* eslint-disable max-len */
import MultimidiaBase from "./MultimidiaBase";

export default class MultimidiaBrumadinho extends MultimidiaBase { 
	constructor(props) {
		super(props);
		this.title = "Multimídia Brumadinho";

		this.groups = [
			{
				id: 1,
				name: "Avaliação da Qualidade da Água do Rio Paraopeba PEQ/COPPE/UFRJ",
				coordinators: "Prof. Cristiano Piacsek e Profª. Fabiana Valéria Fonseca",
				videos: [
					{
						state: 'isOpenAluminioDissolvidoBrumadinho',
						imgur: "/multimidia/rq6KxhF.png",
						titulo: "Alumínio Dissolvido (mg/L)",
						videoID: 'aKGn3G9gssc',
						periodo: "Abr/2019 a Ago/2019",
						metodo: "Interpolação Discreta"
					},
					{
						state: 'isOpenFosforoTotalBrumadinho',
						imgur: "/multimidia/Cx7dKXA.png",
						titulo: "Fósforo total (mg/L)",
						videoID: 'TmD3v8kbDy0',
						periodo: "Abr/2019 a Ago/2019",
						metodo: "Interpolação Discreta"
					},
					{
						state: 'isOpenManganesTotalBrumadinho',
						imgur: "/multimidia/RjWqqbY.png",
						titulo: "Manganês total (mg/L)",
						videoID: "qMu6x0nIPnQ",
						periodo: "Abr/2019 a Ago/2019",
						metodo: "Interpolação Discreta"
					},
					{
						state: 'isCobreDissolvidoBrumadinho',
						imgur: "/multimidia/qqwPFJB.png",
						titulo: "Cobre Dissolvido (mg/L)",
						videoID: 'IAxizPCoAr0',
						periodo: "Abr/2019 a Ago/2019",
						metodo: "Interpolação Discreta"
					},
					{
						state: 'isOpenFerroDissolvidoBrumadinho',
						imgur: "/multimidia/W73brg6.png",
						titulo: "Ferro Dissolvido (mg/L)",
						videoID: 'D4kUOQzlyFc',
						periodo: "Abr/2019 a Ago/2019",
						metodo: "Interpolação Discreta"
					},
					{
						state: 'isOpenNitratoBrumadinho',
						imgur: "/multimidia/onhPj2m.png",
						titulo: "Nitrato (mg/L)",
						videoID: "nPO7LT_Rmdk",
						periodo: "Abr/2019 a Ago/2019",
						metodo: "Interpolação Discreta"
					},
					{
						state: 'isOpenTurbidezBrumadinho',
						imgur: "/multimidia/2FDi9Kw.png",
						titulo: "Turbidez (UNT)",
						videoID: 'T4KVjFomfao',
						periodo: "Abr/2019 a Ago/2019",
						metodo: "Interpolação Discreta"
					}
				]
			},
			{
				id: 2,
				name: "Avaliação de odores na região afetada pelo rejeito da barragem de Córrego do feijão, em Brumadinho/MG - IVIG",
				coordinators: "Prof. Marco Aurélio Vasconcelos de Freitas",
				videos: [
					{
						state: 'isOpenVideo1',
						imgur: "/multimidia/ROCURfgXPpA.jpg",
						titulo: "Sobrevoo pós-rompimento da barragem de Córrego do Feijão com o objetivo de reconhecimento da área de estudo - Video 1",
						videoID: 'ROCURfgXPpA',
						periodo: "14/05/2019",
						metodo: "drone"
					},
					{
						state: 'isOpenVideo2',
						imgur: "/multimidia/Z4qgjVABzYw.jpg",
						titulo: "Sobrevoo pós-rompimento da barragem de Córrego do Feijão com o objetivo de reconhecimento da área de estudo - Video 2",
						videoID: 'Z4qgjVABzYw',
						periodo: "14/05/2019",
						metodo: "drone"
					},
					{
						state: 'isOpenVideo3',
						imgur: "/multimidia/ktiFnFfOOkc.jpg",
						titulo: "Sobrevoo pós-rompimento da barragem de Córrego do Feijão com o objetivo de reconhecimento da área de estudo - Video 3",
						videoID: 'ktiFnFfOOkc',
						periodo: "14/05/2019",
						metodo: "interpolação"
					},
					{
						state: 'isOpenVideo4',
						imgur: "/multimidia/tlCFSVAsJIU.jpg",
						titulo: "Concentração de Odores",
						videoID: 'tlCFSVAsJIU',
						periodo: "2014 a 2018",
						metodo: "interpolação"
					},
					{
						state: 'isOpenVideo5',
						imgur: "/multimidia/HDXSAfmYKQ0.jpg",
						titulo: "Concentração de Odores",
						videoID: 'HDXSAfmYKQ0',
						periodo: "2014 a 2018",
						metodo: "Blocos de Quadrícula"
					}
				]
			}
		];
	}
}


// WEBPACK FOOTER //
// ./src/components/Multimidia/MultimidiaBrumadinho.js